import { Link, useParams } from "react-router-dom";
import "./index.scss";
import { faArrowLeft, faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import Slider from "../Slider";


const ProjectDetail = () => {
  let { projectName } = useParams();
  const [project, setProject] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // useEffect(() => {
  //   fetchProjectDetail();
  // });

  // const fetchProjectDetail = async () => {
  //   try {
  //     const q = query(
  //       collection(db, "projects"),
  //       where("name", "==", projectName)
  //     );

  //     const querySnapshot = await getDocs(q);
  //     if (querySnapshot.empty) {
  //       setError("No project found with the provided name.");
  //     } else {
  //       setProject(querySnapshot.docs[0].data());
  //     }
  //   } catch (e) {
  //     setError("Something went wrong! Couldn't fetch data at this moment");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  useEffect(() => {
    let isMounted = true; // Track whether the component is mounted
  
    const fetchProjectDetail = async () => {
      try {
        const q = query(
          collection(db, "projects"),
          where("name", "==", projectName)
        );
  
        const querySnapshot = await getDocs(q);
        if (isMounted) {
          if (querySnapshot.empty) {
            setError("No project found with the provided name.");
          } else {
            setProject(querySnapshot.docs[0].data());
          }
        }
      } catch (e) {
        if (isMounted) {
          setError("Something went wrong! Couldn't fetch data at this moment");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };
  
    fetchProjectDetail();
  
    return () => {
      isMounted = false; // Cleanup function sets isMounted to false
    };
  }, [projectName]);
  

  const renderShimmer = () => {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  };

  const renderError = () => {
    return (
      <div className="loader-container">
        <div className="error"> {error}</div>
      </div>
    );
  };

  const renderProject = ({
    name,
    live_url,
    repo,
    images,
    description,
    tech_stack,
    features,
  }) => {
    return (
      <>
        <div className="project-header">
          <div className="project-title">
            <Link
              to="/projects"
              className="back-link"
              aria-label="Back to all projects"
              title="Back to all projects"
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </Link>
            <h1>{name}</h1>
          </div>
          <div className="project-socials">
            <a className={`project-social ${!live_url ? 'disable': ''}`} href={live_url}>
              <FontAwesomeIcon size="lg" icon={faShare} />
              <span className="title">Live URL</span>
            </a>
            <a className={`project-social ${!repo ? 'disable': ''}`} href={repo}>
              <FontAwesomeIcon size="lg" icon={faGithub} />
              <span className="title">{repo ? "Github" : "No Repo"}</span>
            </a>
          </div>
        </div>
        <Slider images={images} name={name} />
        {/* <div className="project-images">
          <img src={`${images[0]}`} alt={name}></img>
        </div> */}
        {description.map((desc) => {
            return <p key={desc}>{desc}</p>;
          })}
        <div className="tech-stack">
          <h2>Technology Stack</h2>
          <div>
            {tech_stack &&
              Object.entries(tech_stack).map(([key, values], idx) => (
                <ul key={idx}>
                  <li>
                    {key}
                    {" : "}
                    {values.map((val, i) => (
                      <span key={val}>
                        {val}
                        {i !== values.length - 1 && ", "}
                      </span>
                    ))}
                  </li>
                </ul>
              ))}
          </div>
        </div>
        <div className="features">
          <h2>Key Features</h2>
          {features &&
            Object.entries(features).map(([key, values], idx) => (
              <ul key={idx}>
                <li>
                  {key}
                  {" : "}
                  {values.map((val, i) => (
                    <span key={val}>
                      {val}
                      {i !== values.length - 1 && ", "}
                    </span>
                  ))}
                </li>
              </ul>
            ))}
        </div>
      </>
    );
  };

  return (
    <div className="container project-detail">
      <div className="text-zone">
        {/* Keep a page heading while data loads or fails; the visible one comes with the project */}
        {(loading || error) && <h1 className="sr-only">{projectName}</h1>}
        {loading
          ? renderShimmer()
          : error
          ? renderError()
          : renderProject(project)}
      </div>
    </div>
  );
};

export default ProjectDetail;
